import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IFilters } from 'coreOld/types';
import { getFormData, getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { ISystemUser } from 'system/types';

export const getAll = async (
  filters: IFilters,
  signal?: AbortSignal
): Promise<GetManyResponse<ISystemUser>> => {
  const { data } = await partfinitiClient.get(
    `/user/list/users?${getQueryString(objectKeysCamelToSnakeCase(filters))}`,
    signal
  );

  return mapRecordsFromServer<ISystemUser>(data.data, data.recordsFiltered);
};

export const editBulk = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/edit/save-bulk', dataToSend);
};

export const blockIpBulk = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/edit/block-ip-bulk', dataToSend);
};

export const unblockIpBulk = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/edit/unblock-ip-bulk', dataToSend);
};

export const editUserSettings = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/setting-edit/save', dataToSend);
};

export const editUserSettingsBulk = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/setting-edit/save-bulk', dataToSend);
};
